import { MessageCircle, Phone } from "lucide-react";
import { Reveal } from "./Reveal";
import { SITE, WA_BOOK } from "../../lib/site";

const CTASection = () => (
    <section
        data-testid="cta-section"
        className="relative overflow-hidden py-32 md:py-44"
    >
        <div className="absolute inset-0">
            <img
                src="/images/hero.jpg"
                alt=""
                aria-hidden="true"
                loading="lazy"
                className="h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-emerald-950/85" />
        </div>
        <div className="relative z-10 mx-auto max-w-4xl px-6 text-center md:px-12">
            <Reveal>
                <img
                    src="/logo.png"
                    alt="Flammingo Luxurious Spa emblem"
                    className="mx-auto mb-10 h-20 w-20 rounded-full object-cover ring-1 ring-gold/60"
                />
            </Reveal>
            <Reveal delay={0.1}>
                <h2 className="font-serif text-5xl leading-tight tracking-tight text-cream sm:text-6xl md:text-7xl">
                    Your Escape{" "}
                    <span className="italic text-gold-light">Awaits.</span>
                </h2>
            </Reveal>
            <Reveal delay={0.2}>
                <p className="mx-auto mt-7 max-w-xl text-base font-light leading-relaxed tracking-wide text-sage md:text-lg">
                    Step away from the everyday and discover your moment of
                    relaxation at Flammingo Luxurious Spa.
                </p>
            </Reveal>
            <Reveal delay={0.3}>
                <div className="mt-11 flex flex-wrap items-center justify-center gap-5">
                    <a
                        href={SITE.phoneHref}
                        data-testid="cta-call-button"
                        className="inline-flex items-center gap-3 bg-gold px-9 py-4 text-xs font-medium uppercase tracking-[0.25em] text-emerald-950 transition-colors duration-300 hover:bg-gold-light"
                    >
                        <Phone size={15} aria-hidden="true" />
                        Call {SITE.phoneDisplay}
                    </a>
                    <a
                        href={WA_BOOK}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="cta-whatsapp-button"
                        className="inline-flex items-center gap-3 border border-cream/30 px-9 py-4 text-xs font-medium uppercase tracking-[0.25em] text-cream transition-colors duration-300 hover:border-gold hover:text-gold"
                    >
                        <MessageCircle size={15} aria-hidden="true" />
                        Book Your Experience
                    </a>
                </div>
            </Reveal>
        </div>
    </section>
);

export default CTASection;
